import { render, staticRenderFns } from "./DespachoRecepcion.vue?vue&type=template&id=5ebf8e38&"
import script from "./DespachoRecepcion.vue?vue&type=script&lang=js&"
export * from "./DespachoRecepcion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports